import { getBasenameWithoutExtension, getExtname } from '../platformAbstraction/pathComposition';

// Builds search string for items having similar filename and duration
export function getSimilarItemsSearchString(fileName: string, exactFileNameSearch: boolean, originClipMediaDurationMs: number | undefined, durationTolerance: number | undefined) {
  const fileNameWithoutExtension = getBasenameWithoutExtension(fileName, '/');
  const fileExtension = getExtname(fileName, '/');

  // - We are adding both "itemState:complete" and "itemState:error" here to exclude placeholders with failed uploads and
  // to include items that are in error state for non-transcoding ops (e.g. transcription). Currently, I don't see any
  // other good way to get only the items with valid highres without introducing search filter changes in the backend.
  // - It seems itemState like this becomes OR, and then the fileName is ANDed with them.
  // - The quotes around fileName is needed for exact match. Note that it does not work if the search is re-applied from
  // state saved in the UI, since that filters out the quotes.
  // - We need to get hit with GUID suffixed filenames which occur in some ingest scenarios (item ID suffixed to filename
  // to make them unique inside a bucket folder). This is why we are using the OR query with wildcards.
  const fileNameSearchString = `(${fileName})||(${fileNameWithoutExtension}_????????-????-????-????-????????????${fileExtension})`;

  const fileNameFilter = exactFileNameSearch ? 'fileName' : 'fileNameNormalized';
  let searchString = `itemState:complete itemState:error ${fileNameFilter}:"${fileNameSearchString}"`;

  // Add duration filter if available. For images, it is not available. For aegraphic files, it is available in Premiere,
  // but the Mimir items do not store the duration and are of itemType "file".
  const isAegraphic = fileExtension.endsWith('.aegraphic');
  if (originClipMediaDurationMs && !isAegraphic) {
    // Set the range within durationTolerance seconds of the duration to account for
    // differences between what Premiere reports and what we get from ffprobe.
    const tolerance = durationTolerance ?? 5000;
    const lowerLimitS = Math.max((originClipMediaDurationMs - tolerance) / 1000, 0).toFixed(3);
    const upperLimitS = ((originClipMediaDurationMs + tolerance) / 1000).toFixed(3);
    searchString = `${searchString} mediaDuration:[${lowerLimitS} to ${upperLimitS}]`;
  }

  return searchString;
}
